import React, { useState } from 'react';
import { Container, TextField, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography } from '@mui/material';

const FinancialTarget = () => {
    const [salesTargets, setSalesTargets] = useState({
        2021: 0,
        2022: 0,
        2023: 0,
        2024: 0,
        2025: 0
    });

    const [revenue, setRevenue] = useState({
        2021: 0,
        2022: 0,
        2023: 0,
        2024: 0,
        2025: 0
    });

    const [directCosts, setDirectCosts] = useState({
        2021: 0,
        2022: 0,
        2023: 0,
        2024: 0,
        2025: 0
    });

    const handleSalesChange = (year, value) => {
        const updatedSalesTargets = { ...salesTargets, [year]: value };
        setSalesTargets(updatedSalesTargets);
        updateFinancials(updatedSalesTargets);
    };

    const updateFinancials = (updatedSalesTargets) => {
        const newRevenue = {};
        const newDirectCosts = {};
        Object.keys(updatedSalesTargets).forEach(year => {
            newRevenue[year] = updatedSalesTargets[year] * 100; // örnek hesaplama
            newDirectCosts[year] = updatedSalesTargets[year] * 50; // örnek hesaplama
        });
        setRevenue(newRevenue);
        setDirectCosts(newDirectCosts);
    };

    return (
        <Container>
            <Typography variant="h4" gutterBottom>Satış Hedefleri - Adet</Typography>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            {Object.keys(salesTargets).map(year => (
                                <TableCell key={year}>{year}</TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            {Object.keys(salesTargets).map(year => (
                                <TableCell key={year}>
                                    <TextField
                                        type="number"
                                        value={salesTargets[year]}
                                        onChange={(e) => handleSalesChange(year, parseInt(e.target.value))}
                                        variant="outlined"
                                        size="small"
                                    />
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>

            <Typography variant="h5" gutterBottom>Ciro</Typography>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            {Object.keys(revenue).map(year => (
                                <TableCell key={year}>{year}</TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            {Object.keys(revenue).map(year => (
                                <TableCell key={year}>{revenue[year]}</TableCell>
                            ))}
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>

            <Typography variant="h5" gutterBottom>Doğrudan Maliyet</Typography>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            {Object.keys(directCosts).map(year => (
                                <TableCell key={year}>{year}</TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            {Object.keys(directCosts).map(year => (
                                <TableCell key={year}>{directCosts[year]}</TableCell>
                            ))}
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        </Container>
    );
};

export default FinancialTarget;